import { BotId } from '@feedyou-ai/feedbot-schema'
import { getHostingResourceGroupId, getNativeResourceGroupId } from '@feedyou/utils'

export const doesBotHaveNativeApiUrl = (botId: BotId, botApiUrl: string | undefined): boolean => {
  if (!botApiUrl) {
    return false
  }

  const namespace = window.REALTIME_NAMESPACE || ''
  const nativeId = getNativeResourceGroupId(botId, namespace)
  const launchedId = getHostingResourceGroupId(botApiUrl)

  return nativeId === launchedId
}
